import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ReportingPage } from 'pages/reporting/Reporting'

export const Route = createFileRoute('/reporting/{-$siteID}/')({
  component: ReportingRouteComponent,
  staticData: {
    title: 'Reporting',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})

function ReportingRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <ReportingPage />
}
